export default {
  ADMIN: "admin",
  AUTHOR: "author",
  TEACHER: "teacher",
  STUDENT: "student",
  UNDEFINED: "undefined"
};
